import React, { useEffect, useState, useRef } from 'react';
import './MakingOfPage.css';

const ComparisonSlider = ({ beforeSrc, afterSrc }) => {
  const [position, setPosition] = useState(50);
  const [isDragging, setIsDragging] = useState(false);
  const sliderRef = useRef(null);

  const startPointer = (clientX) => {
    if (!sliderRef.current) return;
    const rect = sliderRef.current.getBoundingClientRect();
    const x = clientX - rect.left;
    const percentage = Math.max(0, Math.min(100, (x / rect.width) * 100));
    setPosition(percentage);
  };

  const onMouseDown = (e) => {
    setIsDragging(true);
    e.preventDefault();
    const onMove = (evt) => startPointer(evt.clientX);
    const onUp = () => {
      setIsDragging(false);
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
    };
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
    startPointer(e.clientX);
  };

  const onTouchStart = (e) => {
    setIsDragging(true);
    const onMove = (evt) => startPointer(evt.touches[0].clientX);
    const onEnd = () => {
      setIsDragging(false);
      document.removeEventListener('touchmove', onMove);
      document.removeEventListener('touchend', onEnd);
    };
    document.addEventListener('touchmove', onMove, { passive: false });
    document.addEventListener('touchend', onEnd);
    startPointer(e.touches[0].clientX);
  };

  if (!beforeSrc || !afterSrc) return null;

  return (
    <div
      className="image-comparison-container"
      ref={sliderRef}
      onMouseDown={onMouseDown}
      onTouchStart={onTouchStart}
      role="group"
      aria-label="Bildvergleich"
    >
      <img className="sizer" src={beforeSrc} alt="" aria-hidden="true" />

      <div className="image-layer">
        <img src={afterSrc} alt="Nachher" />
        <span className="comparison-label label-after">NACHHER</span>
      </div>

      <div
        className="image-layer top-layer"
        style={{
          clipPath: `inset(0 ${100 - position}% 0 0)`,
          transition: isDragging ? 'none' : 'clip-path 0.1s ease-out'
        }}
      >
        <img src={beforeSrc} alt="Vorher" />
        <span className="comparison-label label-before">VORHER</span>
      </div>

      <div
        className="slider-handle"
        style={{
          left: `${position}%`,
          transition: isDragging ? 'none' : 'left 0.1s ease-out'
        }}
        aria-hidden
      >
        <div className="slider-line"></div>
        <div className="slider-button">
          <span>‹</span>
          <span>›</span>
        </div>
      </div>
    </div>
  );
};

const MakingOf = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetch('/data/making-of.json')
      .then((r) => r.json())
      .then((data) => {
        const sorted = [...data].sort((a, b) => a.id - b.id);
        setItems(sorted);
      })
      .catch((e) => console.error('Failed to load making-of.json', e));
  }, []);

  return (
    <div className="making-of-container">
      <div className="headline">
        <h2 className="title">Making Of</h2>
      </div>

      <div className="making-of-content">
        {items.map(({ id, before, after, credits }) => (
          <div className="comparison-section" key={id}>
            <ComparisonSlider
              beforeSrc={`/assets/projects/making_of/${before}`}
              afterSrc={`/assets/projects/making_of/${after}`}
            />
            {credits && (
              <div className="credits">
                <span>{credits}</span>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MakingOf;
